import {Component, Input, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {Language, TranslateService} from '@ngx-translate/core';
import {getAppThemeName} from 'src/app/core/functions/common.function';
import {DBIconModule, DBMenuModule, DBSelectOption} from "@db/db-core";
import {CommonModule} from "@angular/common";
import {BehaviorSubject} from "rxjs";

@Component({
  selector: 'language-menu',
  templateUrl: './language-menu.component.html',
  imports: [
    DBMenuModule,
    DBIconModule,
    CommonModule
  ],
  standalone: true,
  styleUrls: ['./language-menu.component.scss']
})
export class LanguageMenuComponent implements OnInit, OnDestroy {
  dbSelectOptions: DBSelectOption[] = [];
  currentLang: Language | null = null;
  public getThemeName?: string;
  private _color = '#fff'
  public _isMenuOpen: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private _iconOnly: boolean = false;
  private outsideClickListener!: () => void;

  @Input()
  set color(color: string) {
    this._color = color;
  }

  @Input()
  set iconOnly(value: boolean) {
    this._iconOnly = value;
  }

  constructor(
    private translate: TranslateService,
    private renderer: Renderer2
  ) {
  }

  ngOnInit(): void {
    this.getThemeName = getAppThemeName();
    this.currentLang = this.translate.getCurrentLang() || this.translate.getFallbackLang();

    this.translate.getLangs().forEach(lang => {
      const option = { label: lang.toUpperCase(), value: lang };
      if (!this.dbSelectOptions.some(item => item.label === option.label)) {
        this.dbSelectOptions.push(option);
      }
    });
    this.outsideClickListener = this.renderer.listen('document', 'click', (event: Event) => {
      const target = event.target as HTMLElement;
      const menu = document.getElementsByClassName('db-overlay is-visible')[0] as HTMLElement;
      console.log(menu);
      if (!menu) {
        return;
      }
      this.setMenuIcon(menu.contains(target) ? this._isMenuOpen.value : !this._isMenuOpen.value);
    });
  }

   ngOnDestroy() {
    if (this.outsideClickListener) {
      this.outsideClickListener();
    }
  }

  setActiveLanguage(event: any) {
    const lang = event.target.innerText.toLowerCase();
    this.translate.use(lang);
    this.currentLang = lang;
    this.setMenuIcon(!this._isMenuOpen.value);
  }

  setMenuIcon(value: boolean) {
    this._isMenuOpen.next(value);
  }

  get isMenuOpen() {
    return this._isMenuOpen.value;
  }

  get color() {
    return this._color;
  }

  get iconOnly() {
    return this._iconOnly;
  }

  get languages() {
    return this.translate.getLangs();
  }

  protected readonly window = window;
  protected readonly getAppThemeName = getAppThemeName;
}
